// @ts-expect-error importing binary fiel generated error
import speedTestAsset from "app/download/500000.bin";
import NetworkSpeed from "network-speed";
import ENV from "../../config";
import store from "../store/store";
const testNetworkSpeed = new NetworkSpeed();
export class DownloadSpeedHelper {
  static async getNetworkDownloadSpeed() {
    // external hosted file url
    // added timestamp to request to prevent browser caching of downloaded asset
    const baseUrl =
      "https://eu.httpbin.org/stream-bytes/500000?t=" + Date.now();
    //local version of file
    const localUrl = `${ENV.SPEED_URL}${speedTestAsset}?t=${Date.now()}`;
    // file size in bytes
    const fileSizeInBytes = 500000;
    // check how long it takes the request to download fileSizeInBytes
    // not ideal workaround for infra CORS issue
    // use external asset for locaalhost as request throws a cors error
    // otherwise use localUrl
    const speed = await testNetworkSpeed.checkDownloadSpeed(
      window.location.hostname === "localhost" ? baseUrl : localUrl,
      fileSizeInBytes
    );
    // save network download speed to store
    store.dispatch.sessionModel.setDownloadSpeed(speed);
  }
}
